export const CustomLoginSteps = {
	UsernameStep: 1,
	PasswordStep: 2,
	EmailStep: 3,
};

export const MaxAttempts = 3;

export const EmailVerificationFormName = "emailVerificationForm";
export const LoginFormName = "loginForm";
